export enum ReportFileType {
  Selver_SalesReport_SalesFile = 1,
  Selver_SalesReport_InventoryFile = 2
}

(ReportFileType as any).__typeName = 'ReportFileType';
